module.exports = __webpack_public_path__ + "img/no-data__for_dark_bg.3faf124.png";